var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('timer',{attrs:{"color":_vm.color,"time":_vm.ghost ? _vm.ghost: _vm.playtime,"aria-label":_vm.a11y.current,"tabindex":"0","data-test":"timer-current"}})}
var staticRenderFns = []

export { render, staticRenderFns }